import React from 'react';
import { FaCheck, FaInfoCircle } from 'react-icons/fa';

import {
  CompanyInfoPanel,
  CompanyInfoIcon,
  CompanyInfoContent,
  CompanyInfoHeader,
  CompanyInfoFeatures,
  CompanyInfoFeature,
  CompanyInfoNote,
} from './Info.styles';

const Info = () => {
  return (
    <CompanyInfoPanel>
      <CompanyInfoIcon>
        <FaInfoCircle />
      </CompanyInfoIcon>

      <CompanyInfoContent>
        <CompanyInfoHeader>
          <span>Company Account</span>

          <h3>Set Up Your Company</h3>

          <p>
            Add the basic information for your company. Once your company
            account is created, you&apos;ll be able to manage your team and
            their workplace training from one place.
          </p>
        </CompanyInfoHeader>

        <CompanyInfoFeatures>
          <CompanyInfoFeature>
            <FaCheck />
            <span>Add and manage employees</span>
          </CompanyInfoFeature>

          <CompanyInfoFeature>
            <FaCheck />
            <span>Purchase and assign training</span>
          </CompanyInfoFeature>

          <CompanyInfoFeature>
            <FaCheck />
            <span>Track training progress and expirations</span>
          </CompanyInfoFeature>

          <CompanyInfoFeature>
            <FaCheck />
            <span>Manage company training records</span>
          </CompanyInfoFeature>
        </CompanyInfoFeatures>

        <CompanyInfoNote>
          You don&apos;t need to set everything up today. You can add employees
          and complete additional company details after your account has been
          created.
        </CompanyInfoNote>
      </CompanyInfoContent>
    </CompanyInfoPanel>
  );
};

export default Info;
